import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
declare let $: any;


@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.scss']
})
export class CustomerSearchComponent implements OnInit {

  
  Row = [];
  constructor(public appservice: AppService,private router: Router) {
     this.appservice.Status="A";
    // this.appservice.Cus_Type="Ledger";
     this.appservice.cus_order_by=" cus_name asc";
    this.appservice.get_SLedger_Master();
   
  }

  public page="master/add-customer";

  addReset() {
    this.appservice.isadd = "0";
    this.appservice.isEdit=false;
    if(this.appservice.Ledger_Type=="1")
    {
      this.page="master/add-customer";
      this.appservice.Cus_Type="Ledger";
    }
    else
    {
      this.page="master/add-supplier";
      this.appservice.Cus_Type="Supplier";
    }
    return this.router.navigate([this.page]);
  }

 
  

  select_Ledger(rowData) {
    this.appservice.from_customer_page=true;
    this.appservice.Selected_Customer = rowData;
    this.appservice.back();
  }

  selected_row1(row_No, dt) {


    var len = 0;
    try {
      len = dt.filteredValue.length;

    } catch { }


    if (len == 0) {
      this.select_Ledger(dt.value[row_No]);
      
    }
    else {
      this.select_Ledger(dt.filteredValue[row_No]);
      
    }
    
  }


  row_No = -1;

  up() {
    if (this.row_No >= 0) {
      this.row_No = this.row_No - 1;
    }
  }

  down() {
    this.row_No = this.row_No + 1;
  }


  ngOnInit(): void {
    $(".itext").focus();
  }


}
